import type * as Types from '../../generated/graphql-types';

import { gql } from '@apollo/client';
export type PessoaFieldsFragment = { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento: any, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null };

export type PessoaBasicFieldsFragment = { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa };

export type FuncionarioFieldsFragment = { __typename: 'FuncionarioType', id: number, matriculaFuncional: string, dataAdmissao?: any | null, status: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento: any, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, cargos?: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, cargo: { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null } }> | null };

export type AlunoFieldsFragment = { __typename: 'AlunoType', id: number, matricula: string, codigoInep?: string | null, matriculaLegado?: string | null, escolaOrigem?: string | null, modalidadeEnsino?: string | null, recebeBolsaFamilia?: boolean | null, autorizaUsoImagem?: boolean | null, laudoNeeEntregue?: boolean | null, possuiNee?: boolean | null, responsavelGuarda?: string | null, necessidadesEspeciais: Array<string>, recursosAcessibilidade: Array<string>, escolarizacaoForaEscola: boolean, justificativaFaltaDocumento?: string | null, usaTransporteEscolar: boolean, restricoesAlimentares?: Array<string> | null, deficiencias?: Array<{ __typename: 'MultiDeficienciaType', id: number, nome: string }> | null, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento: any, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, matriculas: Array<{ __typename: 'MatriculaType', id: number, status: Types.StatusMatricula, dataMatricula: any, numeroMatricula?: string | null, rematricula: boolean, observacoes?: string | null, anoLetivo?: { __typename: 'AnoLetivoType', id: number, ano: number, dataInicio: any, dataFim: any } | null, turma: { __typename: 'TurmaType', id: number, nome: string, escola: { __typename: 'EscolaType', id: number, nomeFantasia: string }, curso: { __typename: 'CursoType', id: number, nome: string, etapaBNCC?: { __typename: 'BNCCEtapaType', id: number, nome: string } | null } } }>, responsaveis: Array<{ __typename: 'AlunoResponsavelType', id: number, grauParentesco: string, responsavelLegal: boolean, responsavelFinanceiro: boolean, responsavelAcademico: boolean, autorizadoBuscar: boolean, contatoEmergencia: boolean, guardaCompartilhada: boolean, prioridadeContato: number, observacoes?: string | null, ativo: boolean, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null }>, pessoasAutorizadas?: Array<{ __typename: 'PessoaAutorizadaType', id: number, nome: string, documento?: string | null, parentesco?: string | null }> | null, fichaMedica?: { __typename: 'FichaMedicaType', id: number, alergias?: string | null, condicoesMedicas?: string | null, contatoEmergenciaNome?: string | null, contatoEmergenciaTelefone?: string | null, contatoEmergenciaParentesco?: string | null, laudosMedicos?: Array<string> | null, medicamentosContinuos?: string | null, emTratamentoMedico?: boolean | null, tiposTratamentoMedico?: string | null, doencasAnteriores?: string | null, tipoSanguineo?: string | null } | null };

export type ResponsavelFieldsFragment = { __typename: 'ResponsavelType', id: number, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento: any, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }, filhos: Array<{ __typename: 'ResponsaveisOnAlunosType', grauParentesco: string, aluno: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null } }> };

export type PessoaAutorizadaFieldsFragment = { __typename: 'PessoaAutorizadaType', id: number, nome: string, documento?: string | null, parentesco?: string | null, aluno?: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null } | null };

export type CargoFieldsFragment = { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null, cargaHorariaPadrao: number, nivelHierarquico?: number | null, requerExperiencia: boolean, anosExperienciaMinima?: number | null, competenciasExigidas: Array<string>, salarioBase?: number | null, status: Types.StatusCargo, observacoes?: string | null, criadoEm: any, atualizadoEm: any };

export type FuncionarioCargoFieldsFragment = { __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, certificacoesExigidas: Array<string>, documentosEntregues: Array<string>, observacoes?: string | null, criadoEm: any, atualizadoEm: any };

export type UserFieldsFragment = { __typename: 'User', id: string, username: string, email: string, ativo: boolean, criadoEm: any, atualizadoEm: any, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } };

export type UserCompleteFieldsFragment = { __typename: 'User', id: string, username: string, email: string, ativo: boolean, criadoEm: any, atualizadoEm: any, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento: any, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }, vinculos: Array<{ __typename: 'VinculoType', id: number, ativo: boolean, role: { __typename: 'RoleVinculoType', id: number, nome: string }, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, secretaria?: { __typename: 'SecretariaType', id: number, nome: string } | null, user: { __typename: 'UserVinculoType', id: number, username: string, email: string } }> };

export type VinculoFieldsFragment = { __typename: 'Vinculo', id: number, userId: number, roleId: number, escolaId?: number | null, secretariaId?: number | null, ativo: boolean, criadoEm?: any | null, atualizadoEm?: any | null, role: { __typename: 'RoleType', id: number, nome: string }, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, secretaria?: { __typename: 'SecretariaType', id: number, nome: string } | null };



export const PessoaBasicFieldsFragmentDoc = gql`
    fragment PessoaBasicFields on PessoaType {
    id
    nome
    nomeSocial
    cpf
    email
    telefoneCelular
    telefoneFixo
    profissao
    escolaridade
    localTrabalho
    fotoUrl
    status
  }
`;
export const PessoaFieldsFragmentDoc = gql`
    fragment PessoaFields on PessoaType {
    id
    nome
    nomeSocial
    cpf
    dataNascimento
    email
    telefoneCelular
    telefoneFixo
    genero
    fotoUrl
    nomePai
    nomeMae
    emancipado
    rg
    orgaoEmissor
    dataEmissaoRg
    cartaoSus
    profissao
    escolaridade
    religiao
    localTrabalho
    pontoReferencia
    certidaoMatricula
    certidaoTipo
    certidaoTermo
    certidaoLivro
    certidaoFolha
    certidaoCartorio
    certidaoMunicipio
    certidaoUf
    certidaoDataEmissao
    certidaoNascimento
    isRural
    cep
    logradouro
    numero
    complemento
    bairro
    nacionalidade
    idiomaNativo
    dataChegadaBrasil
    nis
    passaporte
    status
    tituloEleitor
    zonaResidencial
    criadoEm
    atualizadoEm
    cidade {
      id
      nome
      uf
    }
    naturalidade {
      id
      nome
      uf
    }
    raca {
      id
      nome
    }
    estadoCivil {
      id
      nome
    }
    tipoSanguineo {
      id
      nome
    }
    user {
      id
      username
    }
  }
`;
export const FuncionarioFieldsFragmentDoc = gql`
    fragment FuncionarioFields on FuncionarioType {
  id
  matriculaFuncional
  dataAdmissao
  status
  pessoa {
    ...PessoaFields
  }
  escola {
    id
    nomeFantasia
  }
  cargos {
    id
    funcionarioId
    cargoId
    dataInicio
    dataFim
    cargaHorariaSemanal
    cargoPrincipal
    ativo
    salario
    cargo {
      id
      nome
      categoria
      descricao
    }
  }
}
    ${PessoaFieldsFragmentDoc}`;
export const AlunoFieldsFragmentDoc = gql`
    fragment AlunoFields on AlunoType {
  id
  matricula
  codigoInep
  matriculaLegado
  escolaOrigem
  modalidadeEnsino
  recebeBolsaFamilia
  autorizaUsoImagem
  laudoNeeEntregue
  possuiNee
  responsavelGuarda
  necessidadesEspeciais
  recursosAcessibilidade
  escolarizacaoForaEscola
  justificativaFaltaDocumento
  usaTransporteEscolar
  restricoesAlimentares
  deficiencias {
    id
    nome
  }
  pessoa {
    ...PessoaFields
  }
  matriculas {
    id
    status
    dataMatricula
    numeroMatricula
    rematricula
    observacoes
    anoLetivo {
      id
      ano
      dataInicio
      dataFim
    }
    turma {
      id
      nome
      escola {
        id
        nomeFantasia
      }
      curso {
        id
        nome
        etapaBNCC {
          id
          nome
        }
      }
    }
  }
  responsaveis {
    id
    pessoa {
      ...PessoaBasicFields
    }
    grauParentesco
    responsavelLegal
    responsavelFinanceiro
    responsavelAcademico
    autorizadoBuscar
    contatoEmergencia
    guardaCompartilhada
    prioridadeContato
    observacoes
    ativo
  }
  pessoasAutorizadas {
    id
    nome
    documento
    parentesco
  }
  fichaMedica {
    id
    alergias
    condicoesMedicas
    contatoEmergenciaNome
    contatoEmergenciaTelefone
    contatoEmergenciaParentesco
    laudosMedicos
    medicamentosContinuos
    emTratamentoMedico
    tiposTratamentoMedico
    doencasAnteriores
    tipoSanguineo
  }
}
    ${PessoaFieldsFragmentDoc}
${PessoaBasicFieldsFragmentDoc}`;
export const ResponsavelFieldsFragmentDoc = gql`
    fragment ResponsavelFields on ResponsavelType {
  id
  pessoa {
    ...PessoaFields
  }
  filhos {
    grauParentesco
    aluno {
      id
      matricula
      pessoa {
        ...PessoaBasicFields
      }
    }
  }
}
    ${PessoaFieldsFragmentDoc}
${PessoaBasicFieldsFragmentDoc}`;
export const PessoaAutorizadaFieldsFragmentDoc = gql`
    fragment PessoaAutorizadaFields on PessoaAutorizadaType {
  id
  nome
  documento
  parentesco
  aluno {
    id
    matricula
    pessoa {
      ...PessoaBasicFields
    }
  }
}
    ${PessoaBasicFieldsFragmentDoc}`;
export const CargoFieldsFragmentDoc = gql`
    fragment CargoFields on CargoType {
  id
  nome
  categoria
  descricao
  cargaHorariaPadrao
  nivelHierarquico
  requerExperiencia
  anosExperienciaMinima
  competenciasExigidas
  salarioBase
  status
  observacoes
  criadoEm
  atualizadoEm
}
    `;
export const FuncionarioCargoFieldsFragmentDoc = gql`
    fragment FuncionarioCargoFields on FuncionarioCargoType {
  id
  funcionarioId
  cargoId
  dataInicio
  dataFim
  cargaHorariaSemanal
  cargoPrincipal
  ativo
  salario
  certificacoesExigidas
  documentosEntregues
  observacoes
  criadoEm
  atualizadoEm
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  username
  email
  ativo
  pessoa {
    ...PessoaBasicFields
  }
  criadoEm
  atualizadoEm
}
    ${PessoaBasicFieldsFragmentDoc}`;
export const UserCompleteFieldsFragmentDoc = gql`
    fragment UserCompleteFields on User {
  id
  username
  email
  ativo
  pessoa {
    ...PessoaFields
  }
  vinculos {
    id
    ativo
    role {
      id
      nome
    }
    escola {
      id
      nomeFantasia
    }
    secretaria {
      id
      nome
    }
    user {
      id
      username
      email
    }
  }
  criadoEm
  atualizadoEm
}
    ${PessoaFieldsFragmentDoc}`;
export const VinculoFieldsFragmentDoc = gql`
    fragment VinculoFields on Vinculo {
  id
  userId
  roleId
  escolaId
  secretariaId
  ativo
  role {
    id
    nome
  }
  escola {
    id
    nomeFantasia
  }
  secretaria {
    id
    nome
  }
  criadoEm
  atualizadoEm
}
    `;